import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { $definitions, } from 'ziphy-web-shared/basic/entities/notes/definitions';
import { splitArray } from 'ziphy-web-shared/basic/helpers';
export const useDefinitionSelectItems = (selectId, options = {}) => {
    const { t } = useTranslation();
    const { customOther, extraField, blocked } = options;
    return useMemo(() => {
        const select = $definitions.selects.items[selectId];
        if (!select)
            return [];
        let options = select.values.map((x) => ({
            id: x.code,
            text: x.title,
            description: x.description,
            disabled: Array.isArray(blocked) ? blocked.includes(x.code) : undefined,
            extraField,
        }));
        if (customOther === false)
            return options;
        if (customOther === 'input' || customOther === 'date' || customOther === 'select') {
            options.push({ id: 'other', text: t('label.other'), extraField: { element: customOther } });
            return options;
        }
        if (customOther) {
            options.push(customOther);
            return options;
        }
        if (select.freeText) {
            if (select.preferred > 0) {
                const [preferred, other] = splitArray(options, select.preferred);
                if (other.length) {
                    preferred.push({
                        id: 'other',
                        text: t('label.other'),
                        extraField: {
                            element: 'select',
                            placeholder: select.freeText.placeholder || select.freeText.title,
                            items: other,
                        },
                    });
                }
                return preferred;
            }
            const typeMapping = { text: 'input', date: 'date', datetime: 'date' };
            const freeTextType = typeMapping[select.freeText.type];
            if (freeTextType) {
                options.push({
                    id: 'other',
                    text: select.freeText.placeholder ? select.freeText.title : t('label.other'),
                    extraField: {
                        element: freeTextType,
                        placeholder: select.freeText.placeholder || select.freeText.title,
                    },
                });
            }
        }
        return options;
    }, [selectId, t, customOther]);
};
